import React, { Component } from "react";
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import ListViewAccordion from "../Components/ListViewAccordion";
import moment from "moment";
import PropTypes from 'prop-types';
import { reverse } from 'lodash';
import { DisplayFlex } from "../../../CommonComponents/commonStyles";
import {
    viewButtonClick,
    dropdownSelect,
    downloadClicked,
    okClicked,
    fetchDocumentCentreData,
    filterGridData,
    multiSelectOption
} from "./actions";
import BreadcrumbComponent from "../../../CommonComponents/Breadcrumb/Breadcrumb";
import { getPrimaryAccount, getAccountData } from "../../../utils/sessionUtil";
import Preloader from '../../../CommonComponents/Preloader/Preloader';
import {
    DocCentreContentWrapper,
    Border,
    DocCentreFilterWrapper,
    ContentContainer,
    DocumentCentreHeading,
    FlexCenter,
    DocumentOptionsWrapper,
    FundNameWrapper,
    AccountIdWrapper,
} from "../Components/styles";
import Calendar from '../Components/DateTimepicker/calendar';
import GridViewAccordion from "../Components/GridViewAccordion";
import MultiSelect from "../Components/MultiSelect";
import ViewButtonsComponent from "../Components/ViewButtonsComponent";
import TimeFrameComponent from "../Components/TimeFrameComponent";
import { milliToDate, todayDate } from "../../../utils/commonUtil";
import { ContentProvider, Types, ContentMessage } from "./../../../CommonComponents/ContentMessages";

let prevCustDates = [];
let prevCustData = [];
let prevYearData = [];
let iPhone = false;
if (navigator.userAgent.match(/iPhone/i)) {
    if (window.innerWidth < 767) {
        iPhone = true;
    }
}
export class DocumentCentre extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            isMobile: (window.screen.width < 767 || iPhone) ? true : false,
            dropdownValue: [
                "All",
                "Custom Dates",
                "2019",
            ],
            viewButtonValue: true
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.refreshInterval = null;
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.multiSelectOption([], this.state.dropdownValue);
        this.props.viewButtonClick(true)
        let data = {};
        if (process.env.REACT_APP_NODE_ENV === "development") {
            data = {
                metaData: {
                    method: "GET",
                    page: "documentCentre",
                    url: {
                        documentCentre: '/documentCentre/vceptpl/api/documentCentre'

                    }
                }
            };
        } else {
            data = {
                metaData: {
                    method: "GET",
                    page: "documentCentre",
                    url: {
                        documentCentre: `/donor-portal/api/account/${getPrimaryAccount().userId}/getAccountDocumentsByAccountIdAndPartyIdAndType/${getAccountData().partyId}?startDateStr=01/01/1990&endDateStr=${todayDate()}&type=ALL`
                    }
                }
            };
        }
        this.props.documentCentreData(data);
        this.refreshApi(data);
    }

    //Fix for the bug 5044
    refreshApi = (data) => {
        //To refresh the Sec key generated.
        this.refreshInterval = setInterval(() => this.props.documentCentreData(data), 360000)
    };

    componentWillReceiveProps(nextProps) {
        let prevState = this.state;
        let dt = new Date();
        let thisYear = dt.getFullYear()
        let yearsValue = []
        if (nextProps.originalOpenDate) {
            let originalOpenDate = nextProps.originalOpenDate;
            let establishedYear = moment(originalOpenDate).year();
            if (establishedYear < thisYear) {
                for (let i = establishedYear; establishedYear <= thisYear; establishedYear++) {
                    yearsValue.push(establishedYear.toString())
                }
            } else {
                yearsValue.push(thisYear.toString())
            }
        } else {
            yearsValue.push(thisYear.toString())
        }
        yearsValue = reverse(yearsValue);
        prevState.dropdownValue = ["All", "Custom Dates"].concat(yearsValue);
        this.setState(prevState)
    }

    handleCancel() {
        document.body.style.overflow = "";
        this.setState({
            visible: false
        });
    };

    filterDataOnYear = (years) => {
        let filteredData = [];
        filteredData = prevCustData;
        let storeData = this.props.docData;
        let updateFilteredData = [];
        let isTimeFrame = false;
        let isAllSelected = false;
        if (years.length > 0) {
            if (years.length === 1 && years[0] === "Custom Dates") {
                prevYearData = [];
                this.setState({ visible: true });
            } else if (years.length === 1 && years[0] === "All") {
                this.props.updateFilterData(this.props.arrayData);
            } else {
                if (years[years.length - 1] === "Custom Dates") {
                    this.setState({ visible: true });
                } else {
                    for (const key in storeData) {
                        let filteredGridData = [];
                        let gridStoreData = storeData[key];
                        years.map((year) => {
                            if (!(year === "Custom Dates" || year === "All")) {
                                filteredGridData.push(gridStoreData.filter((data) => {
                                    let fulldate = milliToDate(data.date);
                                    let date = fulldate.split('/')[2];

                                    if (year === date) {
                                        return data;
                                    }
                                }));
                            } else {
                                year === "All" ? isAllSelected = true : isTimeFrame = true;
                            }
                        });
                        if (!isTimeFrame) {
                            filteredData = [];
                            prevCustData = [];
                            prevCustDates = [];
                        }
                        let updatedData = [];
                        filteredGridData.map((option) => { option.map((data) => { updatedData.push(data); return true }); return true; });
                        let newArray = [];
                        newArray.push(key);
                        let gridData = filteredData.filter((data) => {
                            if (data[0] === key) {
                                return true;
                            }
                        });
                        if (gridData.length > 0) {
                            if (gridData[0][1].length > 0) {
                                gridData[0][1].foreach((data) => updatedData.push(data));
                            }
                        }
                        newArray.push(updatedData);
                        updateFilteredData.push(newArray);
                    }
                    prevYearData = updateFilteredData;
                    if (isAllSelected) {
                        this.props.updateFilterData(this.props.arrayData);
                    } else {
                        this.props.updateFilterData(updateFilteredData);
                    }
                }
            }
        }
        else {
            prevYearData = [];
            this.props.updateFilterData(this.props.arrayData);
        }
    }

    filterOnCustomDate = (dates) => {
        let prevState = this.state;
        let mainData = this.props.docData;
        let newFilteredData = [];
        let filteredData = prevYearData;
        let isSame = false;
        if (dates === undefined) {
            prevState.visible = false;
        }
        if (dates && dates.value && dates.value.length > 0) {
            if (prevCustDates.value && prevCustDates.value.length > 0) {
                if (prevCustDates.value[0] === dates.value[0] && prevCustDates.value[1] === dates.value[1]) {
                    isSame = true;
                }
            }
            if (!isSame) {
                if (mainData !== undefined) {
                    const date1 = moment(dates.value[0], "MM/DD/YYYY");
                    const date2 = moment(dates.value[1], "MM/DD/YYYY");

                    for (const key in mainData) {
                        let filteredGridData = [];
                        let gridStoreData = mainData[key];
                        filteredGridData = gridStoreData.filter(x => {
                            let dateValue = milliToDate(x.date)
                            if (moment(dateValue, "MM/DD/YYYY") >= date1 && moment(dateValue) <= date2) {
                                prevState.visible = false;
                                return true;
                            } else {
                                prevState.visible = true;
                                return false;
                            }
                        }
                        );
                        let newArray = [];
                        newArray.push(key);
                        let updatedData = [];
                        updatedData = filteredGridData;
                        let gridData = filteredData.filter((data) => {
                            if (data[0] === key) {
                                return true;
                            }
                        });
                        if (gridData.length > 0) {
                            if (gridData[0][1].length > 0) {
                                gridData[0][1].foreach((data) => updatedData.push(data));
                            }
                        }
                        newArray.push(updatedData);
                        newFilteredData.push(newArray);
                    }
                    prevCustDates = JSON.parse(JSON.stringify(dates));
                    prevCustData = newFilteredData;
                    prevState.visible = false;
                    this.props.updateFilterData(newFilteredData);
                    let customDateSelect = moment(date1).format("MM/DD/YYYY") + ' - ' + moment(date2).format("MM/DD/YYYY") + ' Custom Dates'
                    this.props.multiSelectOption(customDateSelect, this.state.dropdownValue);
                }
            } else {
                prevState.visible = false;
            }
        } else {
            prevCustData = [];
            prevCustDates = [];
            this.props.updateFilterData(this.props.arrayData);
        }
        this.setState(prevState)
    }

    breadcrumbRoutes = () => {
        return [
            {
                routeName: "Home",
                path: "/"
            },
            {
                routeName: "My Account",
                path: '/my-account'
            },
            {
                routeName: "My Documents",
                path: "/my-account/my-documents"
            }
        ];
    };

    componentWillUnmount() {
        // clearing the intervals
        if (this.refreshInterval) clearInterval(this.refreshInterval)
    }

    handleViewButtonClick = () => {
        let btnVal = !this.state.viewButtonValue
        this.setState({ viewButtonValue: btnVal })
    }

    render() {
        let primaryAccount = getPrimaryAccount();

        return (
            <ContentProvider data-test="document-centre" types={[Types.PAGE_TITLE_DESCRIPTION]} pages={['My Documents']}>
                <ContentContainer>
                    <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
                    <DocumentCentreHeading>
                        <ContentMessage
                            page='My Documents'
                            type={Types.PAGE_TITLE_DESCRIPTION}
                            property='field_page_title'
                            defaultMessage={<Preloader styling="btnLoader" />}
                        />
                    </DocumentCentreHeading>
                    <div>
                        <FundNameWrapper>
                            {primaryAccount.accountName}
                        </FundNameWrapper>
                        <AccountIdWrapper>
                            {primaryAccount.accountNumber}
                        </AccountIdWrapper>
                    </div>
                    <Border />
                    <DocCentreFilterWrapper>
                        <Row>
                            {
                                (this.state.isMobile)
                                    ?
                                    <Col lg={0} md={0} sm={0} xs={24} >
                                        <DocCentreContentWrapper> Filter by time frame </DocCentreContentWrapper>
                                        <MultiSelect options={this.state.dropdownValue} handleDropper={this.filterDataOnYear} />
                                        <TimeFrameComponent
                                            onCancel={this.handleCancel}
                                            visible={this.state.visible}
                                            onFilterClick={this.filterOnCustomDate}
                                        >
                                            Select TimeFrame
                                        </TimeFrameComponent>
                                        <Border />
                                        <ViewButtonsComponent id="chkViewMob" viewButtonValue={this.state.viewButtonValue} handleViewButtonClick={this.handleViewButtonClick} />
                                        <Border />
                                    </Col>
                                    :
                                    <Col lg={24} xs={0} md={24} sm={0}>
                                        <DocumentOptionsWrapper>
                                            <FlexCenter>
                                                <DocCentreContentWrapper marginRight='20px' >
                                                    Filter by time frame </DocCentreContentWrapper>
                                                <MultiSelect options={this.state.dropdownValue} handleDropper={this.filterDataOnYear} />
                                                <div className={(!this.state.visible && 'hidden')}>
                                                    <Calendar
                                                        visible={this.state.visible}
                                                        onCancel={this.handleCancel}
                                                        onFilterClick={(dates) => { this.filterOnCustomDate(dates) }}
                                                    >
                                                        Select TimeFrame
                                                    </Calendar>
                                                </div>
                                            </FlexCenter>
                                            <DisplayFlex>
                                                <ViewButtonsComponent id="chkView" viewButtonValue={this.state.viewButtonValue} handleViewButtonClick={this.handleViewButtonClick} />
                                            </DisplayFlex>
                                        </DocumentOptionsWrapper>
                                    </Col>
                            }

                        </Row>
                    </DocCentreFilterWrapper>

                    {
                        (this.props.arrayData.length > 0) ?
                            (
                                ((this.state.viewButtonValue)) ?
                                    <GridViewAccordion />
                                    :
                                    <ListViewAccordion />

                            )
                            :
                            <Preloader />}
                </ContentContainer>
            </ContentProvider>
        )
    }
}

DocumentCentre.propTypes = {
    dropdownVal: PropTypes.string,
    downloadAll: PropTypes.bool,
    exitClick: PropTypes.string,
    docData: PropTypes.object,
    filteredData: PropTypes.array,
    arrayData: PropTypes.array,
    checkboxArray: PropTypes.object,
    selectedLinks: PropTypes.array,
    totalCount: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    originalOpenDate: PropTypes.string,
    viewButtonClick: PropTypes.func.isRequired,
    dropdownSelect: PropTypes.func.isRequired,
    downloadClicked: PropTypes.func.isRequired,
    okClicked: PropTypes.func.isRequired,
    documentCentreData: PropTypes.func.isRequired,
    updateFilterData: PropTypes.func.isRequired,
    multiSelectOption: PropTypes.func.isRequired,
}

export const mapStateToProps = state => (
    {
        dropdownVal: state.getIn(['documentCentre', 'selectDropdown']),
        downloadAll: state.getIn(['documentCentre', 'downloadAll']),
        exitClick: state.getIn(['documentCentre', 'exitClick']),
        docData: state.getIn(['documentCentre', 'docCentreData', 'data']),
        filteredData: state.getIn(['documentCentre', 'filteredData']),
        arrayData: state.getIn(['documentCentre', 'docCentreData', 'arrayData']),
        checkboxArray: state.getIn(['documentCentre', 'checkboxArray']),
        selectedLinks: state.getIn(["documentCentre", "checkboxArray", "selected"]),
        dummyUpdate: state.getIn(["documentCentre", "dummyUpdate"]),
        totalCount: state.getIn(['documentCentre', 'docCentreData', 'length']),
        startDate: state.getIn(['documentCentre', 'dates', 'start']),
        endDate: state.getIn(['documentCentre', 'dates', 'end']),
        originalOpenDate: state.getIn(["messaging", "messages", "additionalAccountDetails", "originalOpenDate"]),

    });

export const mapDispatchToProps = dispatch => (
    {
        viewButtonClick: (val) => dispatch(viewButtonClick(val)),
        dropdownSelect: (value) => dispatch(dropdownSelect(value)),
        downloadClicked: (val) => dispatch(downloadClicked(val)),
        okClicked: (val) => dispatch(okClicked(val)),
        documentCentreData: data => dispatch(fetchDocumentCentreData(data)),
        updateFilterData: data => dispatch(filterGridData(data)),
        multiSelectOption: (value, isCustomDate) => dispatch(multiSelectOption({ value: value, isCustomDate: isCustomDate })),
    }
)

export default connect(mapStateToProps, mapDispatchToProps)(DocumentCentre);